import { useLayoutEffect, useRef } from "react"

interface InputFieldAdornmentProps
  extends React.InputHTMLAttributes<HTMLDivElement> {
  onWidthChange: (width: number) => void
}

export const InputFieldAdornment = ({
  children,
  onWidthChange,
  ...props
}: InputFieldAdornmentProps) => {
  const adornmentRef = useRef<HTMLDivElement>(null)

  const firstUpdate = useRef(true)
  useLayoutEffect(() => {
    onWidthChange(adornmentRef.current?.getBoundingClientRect()?.width)
    const observeTarget = adornmentRef.current
    if (!observeTarget) {
      return
    }
    const resizeObserver = new ResizeObserver((entries) => {
      if (firstUpdate.current) {
        firstUpdate.current = false
        return
      }
      for (const entry of entries) {
        const { inlineSize } = entry.borderBoxSize[0]
        onWidthChange(inlineSize)
      }
    })

    resizeObserver.observe(observeTarget)

    return () => {
      resizeObserver.unobserve(observeTarget)
    }
  }, [onWidthChange])

  return (
    <div ref={adornmentRef} {...props}>
      {children}
    </div>
  )
}
